import classNames from "classnames";

import style from "./ToolButton.module.css";

interface ToolButtonProps extends React.HTMLProps<HTMLDivElement> {
  icon: React.ReactNode;
  isActive?: boolean;
  shouldShowLabel?: boolean;
  label?: string;
  activeLabel?: string;
  hideShadow?: boolean;
  isDisabled?: boolean;
}

export const ToolButton: React.FC<ToolButtonProps> = ({
  icon,
  isActive,
  shouldShowLabel,
  label,
  activeLabel,
  hideShadow,
  isDisabled,
  onClick,
  ...props
}) => {
  return (
    <div
      {...props}
      onClick={isDisabled ? undefined : onClick}
      aria-disabled={isDisabled}
      className={classNames(
        style.buttonWrapper,
        props.className,
        isActive && style.active,
        hideShadow && style.noShadow,
        isDisabled && style.disabled
      )}
      role="button"
    >
      <div className={classNames(style.buttonInside)}>{icon}</div>
      {shouldShowLabel && (
        <div className={style.buttonLabelWrapper}>
          <div className={classNames(style.buttonLabel, !isActive && style.showOnHover)}>
            {isActive ? activeLabel : label}
          </div>
        </div>
      )}
    </div>
  );
};
